export default function IconBackgroundFlowyFigure() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="94" height="94" viewBox="0 0 94 94" fill="none">
            <path
                d="M93.3386 79.4465C91.5143 69.1003 87.67 59.2148 82.0253 50.3544C76.3805 41.4939 69.0459 33.832 60.4401 27.8062C51.8343 21.7803 42.1259 17.5085 31.8691 15.2346C21.6124 12.9608 11.0083 12.7294 0.662109 14.5537L8.18533 57.22C12.9285 56.3836 17.7899 56.4897 22.492 57.5321C27.1941 58.5746 31.6449 60.533 35.5902 63.2955C39.5355 66.058 42.898 69.5706 45.4858 73.6326C48.0736 77.6946 49.836 82.2266 50.6723 86.9697L93.3386 79.4465Z"
                fill="#F2F2F4"/>
        </svg>
    )
}
